import { render } from "./menu.vue?vue&type=template&id=c6bbde96&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=c6bbde96&lang=scss&scoped=true"
import "./menu.vue?vue&type=style&index=1&id=c6bbde96&lang=scss"
script.render = render
script.__scopeId = "data-v-c6bbde96"

export default script